import { TenantModuleFlags } from '../config/tenant';
import { DeviceType, Role } from '../types';

export type RouteAccessReason = 'allowed' | 'role' | 'device' | 'module';

export interface RouteAccessResult {
  allowed: boolean;
  reason: RouteAccessReason;
  missingModules?: string[];
}

interface RouteAccessInput {
  role: Role;
  deviceType: DeviceType;
  isRegistered: boolean;
  modules: TenantModuleFlags;
  allowedRoles?: Role[];
  allowedDeviceTypes?: DeviceType[];
  requiredModules?: Array<keyof TenantModuleFlags>;
}

export const getEffectiveDeviceType = (deviceType: DeviceType, isRegistered: boolean): DeviceType => {
  return isRegistered ? deviceType : 'byod';
};

export const evaluateRouteAccess = ({
  role,
  deviceType,
  isRegistered,
  modules,
  allowedRoles,
  allowedDeviceTypes,
  requiredModules,
}: RouteAccessInput): RouteAccessResult => {
  if (role === Role.Admin) {
    if (requiredModules) {
      const missingModules = requiredModules.filter((moduleName) => !modules[moduleName]);
      if (missingModules.length > 0) {
        return { allowed: false, reason: 'module', missingModules };
      }
    }
    return { allowed: true, reason: 'allowed' };
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return { allowed: false, reason: 'role' };
  }

  const effectiveDeviceType = getEffectiveDeviceType(deviceType, isRegistered);
  if (allowedDeviceTypes && !allowedDeviceTypes.includes(effectiveDeviceType)) {
    return { allowed: false, reason: 'device' };
  }

  if (requiredModules) {
    const missingModules = requiredModules.filter((moduleName) => !modules[moduleName]);
    if (missingModules.length > 0) {
      return { allowed: false, reason: 'module', missingModules };
    }
  }

  return { allowed: true, reason: 'allowed' };
};
